import Fluxible from 'vendor/cnpm/fluxible.v0-4/index';

import NaptimeStore from 'bundles/naptimejs/stores/NaptimeStore';
import PartnersStore from 'bundles/partners-graphql/stores/PartnersStore';
import ApplicationStore from 'bundles/ssr/stores/ApplicationStore';

import 'css!bundles/global-styles/global-element-styles';
// remove the grid import once all bt3-container, bt3-row and bt3-col classes are removed from this bundle
import 'css!bundles/partners-graphql/styl/grid';

import routes from './routes';

const appEnv = new Fluxible({
  component: routes,
});

appEnv.registerStore(ApplicationStore);
appEnv.registerStore(NaptimeStore);
appEnv.registerStore(PartnersStore);

export default appEnv;
